import { NUMBER } from '../../constants/common/number';

export const capitalizeStr = str => {
    if (typeof str === 'string' || str instanceof String) {
        return str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);
    } else {
        console.error('parmeters must be a string');
    }
};

/**
 * Splits a camelCase or PascalCase string into words separated by spaces if the string length is greater than 4.
 * @param {string} str - The input string to split.
 * @returns {string} - The string with spaces inserted before uppercase letters if length > 3, otherwise returns original string.
 */
export const splitStringToWords = str => {
    return str.length > NUMBER.THREE ? str.split(/(?=[A-Z])/).join(' ') : str;
};
